import { app } from '../../../../app';

app.factory('SmsNumberGenerateCode', SmsNumberGenerateCode);

/** @ngInject */
function SmsNumberGenerateCode($resource) {
    return $resource('app/rest/phonenumbers/:id/generateCode', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/list/sms-number-generate-code.service.js